import React, { useContext, useEffect, useState, useRef } from 'react'
import styles from './styles.module.css'
import { StudentsContext } from '../../../utils/context';
import Table from '../../../components/Table';
import Button from '../../../components/Button';
import Modal from './extraModal/AchieveModal'
import { arrayForSelect } from '../../../utils/arrayForSelect';
import { useSelector } from 'react-redux';
import CustomSelect from '../../../components/CustomSelect';


export default function EducUniversalActions() {

  const { allForms, addMode, studentTabData, updateInitialValues, trackDeletion } = useContext(StudentsContext)

  const { values, setFieldValue, setValues } = allForms

  const { severity: educData } = studentTabData || {}

  const lastSyncedRef = useRef(null)

  const [selectedItem, setSelectedItem] = useState(null)
  const { schoolYears } = useSelector(state => state.common)
  const [year, setYear] = useState(null)

  useEffect(() => {
    const dataJson = JSON.stringify(educData)
    if (!addMode && educData && lastSyncedRef.current !== dataJson) {
      lastSyncedRef.current = dataJson
      setValues(prev => ({
        ...prev,
        severity: [...educData]
      }))
      if (updateInitialValues) {
        updateInitialValues('severity', educData)
      }
    }
  }, [educData, addMode, setValues, updateInitialValues])

  const handleYearChange = (name, value) => {
    setYear(value)
  }

  const openModal = (data) => () => {
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const handleSaveItem = (itemData) => {
    if (selectedItem === 'add' || !itemData.id) {
      const newItem = {
        ...itemData,
        id: `new_${Date.now()}`
      }
      setFieldValue('severity', [...(values.severity || []), newItem])
    } else {
      const updated = (values.severity || []).map(item =>
        item.id === itemData.id ? itemData : item
      )
      setFieldValue('severity', updated)
    }
    closeModal()
  }

  const handleDeleteItem = (itemId) => {
    if (!String(itemId).startsWith('new_')) {
      trackDeletion('severity', itemId)
    }
    const filtered = (values.severity || []).filter(item => item.id !== itemId)
    setFieldValue('severity', filtered)
  }

  const renderLi = (item) => {
    const { severity_id, severity_name, severity_level_name } = item
    return (
      <tr key={severity_id} onClick={openModal(item)} style={{ cursor: 'pointer' }}>
        <td>{severity_name || ''}</td>
        <td style={{ textAlign: 'center', background: severity_level_name ? '#DEECFF' : '' }}>
          {severity_level_name || ''}
        </td>
      </tr>
    )
  }

  return (
    <div className={styles.tabWrapper}>
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem === 'add' ? {} : selectedItem}
          height={'430px'}
          addMode={selectedItem === 'add'}
          tabType='severity'
          onSave={handleSaveItem}
          onDelete={handleDeleteItem}
        />
      }

      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow}>
          <CustomSelect
            title='Учебный год'
            valuesName="year"
            options={schoolYears && arrayForSelect(schoolYears, 'name', 'xp_key')}
            width='120px'
            value={year}
            setFieldValue={handleYearChange}
          />
        </div>
        <Table className={styles.table}>
          <thead>
            <tr>
              <th>Показатели</th>
              <th style={{ width: '220px', textAlign: 'center' }}>Уровень выраженности</th>
            </tr>
          </thead>
          <tbody>
            {values.severity?.map(renderLi)}
          </tbody>
        </Table>
        <br />
        {/* <Button onClick={openModal('add')}>Добавить</Button> */}
      </div>
    </div>
  )
}

